export const navigationPaneLabel = "mctUFe";
export default {navigationPaneLabel};